import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/Homepage.css";

const API_URL = "https://okna.co.tz/mrms/Staff.php";

function Homepage() {
  const [loading, setLoading] = useState(true);
  const [activeLogin, setActiveLogin] = useState("staff");
  const [pin, setPin] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // ================= STAFF LOGIN =================
  const handleStaffLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch(`${API_URL}?action=login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!data.token) {
        setError(data.error || "Login failed");
        return;
      }

      // ✅ Save session
      localStorage.setItem("token", data.token);
      localStorage.setItem("staff", JSON.stringify(data.staff));
      localStorage.setItem("name", data.staff.full_name);

      // 🔀 ROLE REDIRECT
      switch (data.staff.role) {
        case "Admin":
          navigate("/admin");
          break;
        case "Chef":
          navigate("/chef");
          break;
        case "Cashier":
          navigate("/cashier"); // ✅ Cashier dashboard
          break;
        case "Waitress":
          navigate("/home");
          break;
        default:
          setError("Role not assigned. Contact admin.");
      }
    } catch {
      setError("Server error. Try again.");
    }
  };

  // ================= PIN LOGIN =================
  useEffect(() => {
    if (pin.length === 4) loginWithPin();
  }, [pin]);

  const loginWithPin = async () => {
    setError("");

    try {
      const res = await fetch(`${API_URL}?action=login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pin }),
      });

      const data = await res.json();

      if (!data.token) {
        setError("Invalid PIN");
        setPin("");
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("staff", JSON.stringify(data.staff));
      localStorage.setItem("name", data.staff.full_name);

      navigate("/home"); // Waitress POS
    } catch {
      setError("Server error");
      setPin("");
    }
  };

  return (
    <div className="homepage">
      {loading ? (
        <div className="loading-screen">
          <h1 className="loading-logo">
            <span>M</span><span>R</span><span>M</span><span>S</span>
          </h1>
          <p className="loading-text">Initializing MRMS...</p>
        </div>
      ) : (
        <div className="page-content">
          <div className="welcome-container">
            <h1 className="main-title">
              WELCOME TO <br />
              <span>MARAFIKI RESTAURANT MANAGEMENT SYSTEM</span>
              <br />
              <span className="mrms-tag">(MRMS)</span>
            </h1>

            <div className="login-box">
              <div className="toggle-buttons">
                <button
                  className={activeLogin === "staff" ? "active" : ""}
                  onClick={() => setActiveLogin("staff")}
                >
                  Staff Login
                </button>
                <button
                  className={activeLogin === "pin" ? "active" : ""}
                  onClick={() => setActiveLogin("pin")}
                >
                  PIN Access
                </button>
              </div>

              {error && <p style={{ color: "red" }}>{error}</p>}

              {activeLogin === "staff" && (
                <form className="login-form" onSubmit={handleStaffLogin}>
                  <input
                    type="email"
                    placeholder="Email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <input
                    type="password"
                    placeholder="Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button type="submit">Sign In</button>
                </form>
              )}

              {activeLogin === "pin" && (
                <div className="pin-form">
                  <input
                    type="password"
                    value={pin}
                    maxLength="4"
                    placeholder="Enter PIN"
                    onChange={(e) =>
                      setPin(e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />
                  <p className="pin-note">Auto login after 4 digits...</p>
                </div>
              )}

              <p className="help-text">
                Forgot credentials? Contact System Administrator.
              </p>
            </div>
          </div>

          <footer className="footer">
            © 2026 MRMS — All Rights Reserved.
          </footer>
        </div>
      )}
    </div>
  );
}

export default Homepage;

